module.exports = __webpack_public_path__ + "static/media/cardiff_1.dcbea51f.jpg";